export const selectTradeLines = (state) => state.appReducer.chart.tradeLines
